<template>
  <form class="form form-loyalty-signup-start mb-0" @submit.prevent="postStart">
    <slide-x-left-transition :duration="400" :delay="300">
      <div v-if="show">
        <ion-button mode="ios"
                    @click="downloadFile"
                    class="mt-10 mb-10">
          <svg class="icon icon-download-outline" style="margin-right: 5px">
            <use xlink:href="#icon-download-outline"></use>
          </svg>
          <span>Pobierz umowę</span>
        </ion-button>
      </div>
    </slide-x-left-transition>
    <hr/>
    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    size="small"
                    fill="outline"
                    @click="resetForm()"
                    class="mt-10">Podpisz kolejną umowę
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import {mapState} from "vuex";
  import Save from '@/services/Save';

  export default {
    name: 'FormLoyaltySignupActivationFinal',
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapState({
        errors: state => state.loyalty.errors,
        signupUuid: state => state.loyalty.signupActivationUuid
      })
    },
    mounted() {
      this.show = true
    },
    methods: {
      downloadFile() {
        this.$store.dispatch('loyalty/LOYALTY_ACTIVATION_FILE_REQUEST', this.signupUuid)
            .then(resp => {
              Save.file(resp, "umowa.pdf", {type: "application/pdf"})
            })
      },
      resetForm() {
        this.$store.commit('loyalty/LOYALTY_RESET_ACTIVATION_SIGNUP')
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP', 0)
      }
    }
  }
</script>